<template>
  <div class="logOffScuess_box">
    <div v-if="del_user_ttl !=0">
      <p class="logOffScuess_title">{{$t('logoff.text2')}}</p>
      <div>
        <p> {{ beginText}}
        </p>
        <p>{{endText}}</p>
      </div>
    </div>
    <div v-if="del_user_ttl ==0">
      <p class="logOffScuess_title">{{$t('logoff.text11')}}</p>
    </div>
    <li class="form_item form_submit"
        @click="getNextStep"
        ref='form_submit'>
      <!-- 确定 -->
      {{$t('toast.comfirmBtn1')}}
    </li>
  </div>
</template>

<script>
import { mailMosk } from '@/utils/utils'
import { getSessionStorage } from '../../utils/stage'
import { appPostMessage } from '@/utils/communication'
export default {
  data() {
    return {
      accountData: '',
      celTime: '',
      beginTime: '',
      endTime: '',
      terminalName: '',
      endText: '',
      beginText: '',
      del_user_ttl: '',
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.accountData = JSON.parse(getSessionStorage('accountStorage'))
      this.del_user_ttl = this.accountData.web_config.del_user_ttl
      this.terminalName = mailMosk(this.accountData.email)
      this.celTime = JSON.parse(getSessionStorage('celTime'))
      this.beginTime = this.getDate(0)
      this.endTime = this.getDate(this.del_user_ttl)
      this.beginText = this.getText(this.$t('logoff.text3'), this.beginTime)
      this.endText = this.getText(this.$t('logoff.text4'), this.endTime)
    },
    getText(data, time) {
      return data.replace('{time}', time)
    },
    getDate(n) {
      var ss = 1000 //一天的毫秒数86400
      var timestamp = new Date().getTime() //获取当前时间戳
      var date1 = new Date(ss * n + timestamp) //加上n天的国际标准日期
      var year = date1.getFullYear() //  返回的是年份
      let month = date1.getMonth() + 1
      let dat = date1.getDate()
      var hour = date1.getHours() // 时
      var minutes = date1.getMinutes() // 分
      let m = month > 9 ? month : '0' + month
      let d = dat > 9 ? dat : '0' + dat
      let h = hour > 9 ? hour : '0' + hour
      let min = minutes > 9 ? minutes : '0' + minutes
      var timeStar = `${year}-${m}-${d} ${h}: ${min}`
      if (n > 0) {
        timeStar = `${year}-${m}-${d} ${h}: ${min}`
      }
      return timeStar //拼接成我们需要的格式返回
    },

    getNextStep() {
      this.$t('logoff.logoffScuessTips')
      setTimeout(() => {
        const appmsg = { code: 8, data: '' }
        appPostMessage(appmsg)
      }, 1000)
    },
  },
}
</script>

<style scoped lang='less'>
.logOffScuess_box {
  padding: 30/75rem;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  p {
    font-size: 28/75rem;
    font-weight: 400;
    color: #707070;
    margin-bottom: 15px;
  }
  .logOffScuess_title {
    font-size: 28/75rem;
    font-weight: 700;
  }
  .form_submit {
    width: 610/75rem;
    height: 76/75rem;
    background: #ff7391;
    opacity: 1;
    border-radius: 6/75rem;
    font-family: 'Microsoft YaHei';
    font-size: 30/75rem;
    color: #fff;
    line-height: 76/75rem;
    letter-spacing: 10/75rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 60/75rem;
  }
}
</style>